<template>
	<div style="height:90%;">
		<textarea :id="editorId"></textarea>
	</div>
</template>

<script>
	
	// import {
	// 	MathMLToLaTeX
	// } from 'mathml-to-latex'
	// const mathml2latex = require('mathml-to-latex');
	// const convert = mathml2latex.convert;
	export default {
		name:"editorComponent",
		props: {
			value: String,
			imgStyle: Object,
			isExternalChange: Boolean,
			// altarr: Object,
		},
		data() {
			return {
				editorId: 'cke_' + Date.now(),
				editor: null,
				originalHtml: "",
				wirisObserver: null, // DOM观察者
				targetSpan: null, // 公式目标元素
				tempImg: null, // 临时图片
				isProcessing: false, // 处理锁
				isRendering: false, // 渲染锁
				lastImageAltSet: new Set(),
				foraltarr: {},
			};
		},
		watch: {
			value(val) {
				if (this.editor) {
					this.closeMathEditorDialog();
					this.originalHtml = val;
					this.editor.setData(val || "");
					this.$nextTick(() => {
						// this.fixFormulaElements();
						// this.renderMathJax('no');
						this.editor.window.$.scrollTo(0, 0);
						// this.reinitFormulaCommand();
					});
				}
			},
		},
		mounted() {
			this.initEditor();
		},
		beforeDestroy() {
			if (!this.editor) return;
			// 销毁DOM观察者
			if (this.wirisObserver) {
				this.wirisObserver.disconnect();
				this.wirisObserver = null;
			}
			// 销毁编辑器
			try {
				this.editor.destroy();
			} catch (e) {}
			this.editor = null;
		},
		methods: {
			standardizeLatex(str) {
				// console.log('strstr', str)
				//当出现单个箭头在下面的情况，不存在上面有内容
				if (str.indexOf("\\leftarrow") > -1 || str.indexOf("\\rightarrow") > -1) {
					let leftarr = /\\underset\{([^}]*)\}\{\\leftarrow\}/g
					str = str.replace(leftarr, "\\overleftarrow{$1}")
					let overrightarr = /\\underset\{([^}]*)\}\{\\rightarrow\}/g
					str = str.replace(overrightarr, "\\overrightarrow{$1}")
				}
				//当出现c
				// str=str.replace(/\\rightharpoonup/g,'\\rightharpoonup')
				// if(str.indexOf('\\rightharpoonup')>-1){
				// 	let rightharpoonu=/\\overset\{\\rightharpoonup\}\{([^}]*)\}/g
				// 	str=str.replace(rightharpoonu,'\\rightharpoonaccent{$1}')
				// }
				//箭头的问题\rightarrow_{2}^{1}
				if (str.indexOf('\\rightarrow\_') > -1) {
					let rightarro = /\\rightarrow\_\{([^}]*)\}\^\{([^}]*)\}/g
					str = str.replace(rightarro, (match, sub1, sup1) => {
						if (sub1 === '' && sup1 !== '') {
							return `\\overset{${sup1}}{\\rightarrow}`;
						} else if (sup1 === '' && sub1 !== '') {
							return `\\overrightarrow{${sub1}}`;
						} else {
							return sub1.length > ssub1up1.length ?
								`\\begin{matrix} ${sup1} \\\\ \\overrightarrow{${sub1}}\\end{matrix}` :
								`\\begin{matrix}{\\underset{\\rightarrow}{${sup1}}} \\\\ ${sub1}\\end{matrix}`;
						}
					});
				}
				//左箭头
				let leftarro = /\\leftarrow\_\{([^}]*)\}\^\{([^}]*)\}/g
				str = str.replace(leftarro, (match, sub1, sup1) => {
					if (sub1 === '' && sup1 !== '') {
						return `\\overset{${sup1}}{\\leftarrow}`;
					} else if (sup1 === '' && sub1 !== '') {
						return `\\overleftarrow{${sub1}}`;
					} else {
						return sub1.length > sup1.length ?
							`\\begin{matrix} ${sup1} \\\\ \\overleftarrow{${sub1}}\\end{matrix}` :
							`\\begin{matrix}{\\underset{\\leftarrow}{${sup1}}} \\\\ ${sub1}\\end{matrix}`;
					}
				});
				// console.log('22222', str)
				//修复需要保留长下划线的逻辑兼容＝上面有文字
				let regex = /\\underset\{―\}\{([^}]*)\}/g;
				str = str.replace(regex, (match, p1) => {
					// p1 是 {} 内的内容（空则为 ''）
					if (p1 === '') {
						// 空内容：返回 \underline{\text{text}}
						return '\\underline{\\text{  }}';
					} else {
						// 有内容：返回 \underline{内容}（不加text）
						return `\\underline{${p1}}`;
					}
				});
				//替换符号方法统一处理
				str = this.symbolFunction(str)
				return str
			},
			 // 对外暴露获取编辑器html
			    getEditorData(){
			        if(!this.editor) return '';
			        return this.editor.getData();
			    },
			    // 对外暴露设置编辑器内容
			    setEditorData(htmlStr){
			        if(!this.editor) return;
			        this.editor.setData(htmlStr || '');
			    },
			symbolFunction(str) {
				const symbolList = ["\\triangle", "\\pi", "\\perp", "\\angle", "\\uparrow", "\\downarrow",
					"\\times", "\\div", "\\therefore", "\\because", "\\pm", "\\cdots",
					"\\cdot", "\\to", "\\qquad", "\\Rightarrow", "\\%", "\\Leftrightarrow", "\\implies",
					"\\forall", "\\exists", "\\in", "\\subseteq", "\\cup", "\\cap", "\\leq",
					"\\geq", "\\neq", "\\sim", "\\approx", "^\\circ", "\\slant", "\\parallelogram", "\\square",
					"\\rectangle", "\\lozenge", "\\circle", "\\odot", "\\arc", "\\parallel",
					"\\urcorner", "\\displaystyle"
				]
				const replaceList = ["△", "π", '⊥', '∠', "↑", "↓", "×", "÷", "∴", "∵", "±", "⋅⋅⋅", "⋅", "→",
					'        ', "⇒", "%", "⇔", "⟹", "∀", "∃", "∈", "⊆", "∪", "∩", "≤",
					"≥", "≠", "~", "≈", "∘", "", "▱", "□", "▭", "◇", "○", "⊙", "⌒", "//", '⌝', ""
				]
				for (let i = 0; i < symbolList.length; i++) {
					if (str.indexOf(symbolList[i]) > -1) {
						const regex = new RegExp(symbolList[i].replace(/\\/g, '\\\\'), 'g');
						str = str.replace(regex, replaceList[i]);
					}
				}
				return str
			},
			// convertMathMLToLaTeX(str) {
			// 	if (!str) return '' // 空值兜底，避免报错
			// 	// 第一步：修复 MathML 编码问题
			// 	let latex = ''
			// 	// console.log('mathML', str)
			// 	try {
			// 		latex = MathMLToLaTeX.convert(str) || str // 核心转换函数
			// 	} catch (e) {
			// 		console.error('MathML转LaTeX失败：', e)
			// 		alert('公式转换失败，请检查公式格式')
			// 		return ''
			// 	}

			// 	//部分公式需要修复成docx兼容的逻辑
			// 	latex = this.standardizeLatex(latex)

			// 	return latex
			// },
			// Wiris弹窗关闭后的业务逻辑
			handleWirisClose() {
				const vm = this;
				if (vm.isProcessing) return;
				vm.isProcessing = true;
				const editorBody = vm.editor.document.$.body;
				let hasFormulaInserted = false;
				let formulaImg = null;
				// 监听编辑器内Wiris图片的插入
				const insertObserver = new MutationObserver((mutations) => {
					mutations.forEach((mutation) => {
						mutation.addedNodes.forEach((node) => {
							if (node.nodeType === 1 && node.classList?.contains(
									'Wirisformula')) {
								hasFormulaInserted = true;
								formulaImg = node;
								// processFormula();
							}
						});
					});
				});
				insertObserver.observe(editorBody, {
					childList: true,
					subtree: true
				});
				// 超时兜底
				const timeoutTimer = setTimeout(() => {
					if (!hasFormulaInserted) {
						formulaImg = editorBody.querySelector('img.Wirisformula');
						hasFormulaInserted = !!formulaImg;
					}
					// processFormula();
				}, 500);
				// 统一处理逻辑
				// function processFormula() {
				// 	insertObserver.disconnect();
				// 	clearTimeout(timeoutTimer);
				// 	if (hasFormulaInserted && formulaImg) {
				// 		let latex = formulaImg.getAttribute('alt') || '';
				// 		let mathml = formulaImg.getAttribute('data-mathml') || '';
				// 		// 调用组件方法（vm.xxx），避免作用域问题
				// 		let convertedLatex = vm.convertMathMLToLaTeX(latex);
				// 		if (convertedLatex === '') return
				// 		// console.log('原始latex：', convertedLatex);
				// 		if (latex == "") {
				// 			editorBody.querySelectorAll('img.Wirisformula').forEach(i => i.remove());
				// 			if (vm.tempImg?.parentNode) vm.tempImg.remove();
				// 			alert('当前公式无法解析')
				// 		}
				// 		// 编辑已有公式
				// 		if (vm.targetSpan) {
				// 			vm.targetSpan.setAttribute('text-latex', convertedLatex);
				// 			vm.targetSpan.setAttribute('data-mathml', mathml);
				// 			// vm.targetSpan.classList.add('current-math');
				// 			vm.targetSpan.innerHTML = `$${convertedLatex}$`;
				// 			vm.targetSpan.setAttribute('contenteditable', 'false');
				// 			vm.targetSpan.style.cursor = 'pointer';
				// 		}
				// 		// 插入新公式
				// 		else {
				// 			const span = document.createElement('span');
				// 			span.className = 'latex-formula';
				// 			// span.classList.add('current-math');
				// 			span.setAttribute('text-latex', convertedLatex);
				// 			span.setAttribute('data-mathml', mathml);
				// 			span.setAttribute('contenteditable', 'false');
				// 			span.style.cursor = 'pointer';
				// 			span.innerHTML = `$${convertedLatex}$`;
				// 			formulaImg.parentNode.insertBefore(span, formulaImg);
				// 		}
				// 	}
				// 	// 清理所有Wiris图片
				// 	editorBody.querySelectorAll('img.Wirisformula').forEach(i => i.remove());
				// 	if (vm.tempImg?.parentNode) vm.tempImg.remove();
				// 	// 同步数据和渲染
				// 	vm.$nextTick(() => {
				// 		if (hasFormulaInserted && formulaImg) {
				// 			vm.$emit('update:value', vm.editor.getData());
				// 			//这里是新的公式编辑器
				// 			const body = vm.editor.document.$.body;
				// 			body.querySelectorAll(".latex-formula").forEach(el => {
				// 				const latex = el.getAttribute("text-latex") || "";
				// 				el.innerHTML = `$${latex}$`;
				// 			});
				// 			vm.originalHtml = vm.editor.getData();
				// 			vm.$emit("update:value", vm.originalHtml);
				// 			vm.$nextTick(() => {
				// 				vm.renderMathJax();
				// 			});
				// 		}
				// 		// 重置状态
				// 		vm.targetSpan = null;
				// 		vm.tempImg = null;
				// 		vm.isProcessing = false;
				// 	});
				// }
			},
			// 监听Wiris弹窗状态
			async watchWirisDialog() {
				const vm = this;
				let lastDialogCount = 0;
				vm.wirisObserver = new MutationObserver((mutations) => {
					const currentDialogs = document.querySelectorAll(
						'.wrs_modal_dialogContainer:not(.wrs_closed)');
					const currentCount = currentDialogs.length;

					// 弹窗关闭
					if (currentCount < lastDialogCount) {
						vm.handleWirisClose();
					}
					if (currentCount > lastDialogCount) {
						console.log('✅ Wiris公式编辑器 已打开，执行居中');
						vm.centerMathTypeDialog();
					}
					lastDialogCount = currentCount;
				});
				// 启动监听
				vm.wirisObserver.observe(document.body, {
					childList: true,
					subtree: true,
					attributes: true,
					attributeFilter: ['class']
				});
			},
			// 强制关闭 MathType/Wiris 公式编辑器弹窗（通用版）
			closeMathEditorDialog() {
				try {
					// 1. 关闭所有 MathType 弹窗（通过标题/按钮特征匹配）
					const mathTypeDialogs = document.querySelectorAll(
						'div[role="dialog"], .wrs_modal, .MathType-dialog, div:has(.MathType)');
					mathTypeDialogs.forEach(dialog => {
						// 隐藏弹窗
						dialog.style.display = 'none';
						dialog.style.visibility = 'hidden';
						dialog.style.opacity = '0';
						dialog.style.pointerEvents = 'none';
						// 给一个标记，避免重复处理
						dialog.setAttribute('data-closed-by-switch', 'true');
					});
					// 3. 关闭 CKEditor 自带弹窗
					if (window.CKEDITOR && window.CKEDITOR.dialog.getCurrent()) {
						window.CKEDITOR.dialog.getCurrent().hide();
					}
					// 4. 重置组件状态
					this.targetSpan = null;
					this.tempImg = null;
					this.isProcessing = false;
					console.log('✅ MathType 弹窗已强制关闭');
				} catch (e) {
					console.warn('关闭 MathType 弹窗时出错：', e);
				}
			},
			centerMathTypeDialog() {
				const dialog = document.querySelector('.wrs_modal_dialogContainer:not(.wrs_closed)');
				if (!dialog) return;
				// 给一点延迟，确保弹窗DOM完全渲染
				setTimeout(() => {
					dialog.style.position = 'fixed';
					dialog.style.top = '50%';
					dialog.style.left = '50%';
					dialog.style.transform = 'translate(-50%, -50%)';
					dialog.style.margin = '0';
					dialog.style.zIndex = '999999'; // 确保在最上层
				}, 50);
			},
			// 重新初始化公式命令
			async reinitFormulaCommand() {
				const vm = this;
				if (!vm.editor) return;
				// 触发contentDom事件重建事件绑定
				vm.editor.fire('contentDom');
				// 异步等待插件初始化
				if (!vm.editor.getCommand('ckeditor_wiris_formulaEditor')) {
					const wirisPlugin = window.CKEDITOR.plugins.get('ckeditor_wiris');
					if (wirisPlugin) {
						await new Promise(resolve => {
							setTimeout(() => {
								wirisPlugin.init(vm.editor);
								resolve();
							}, 50);
						});
					}
				}
				// 修复公式元素样式
				// vm.fixFormulaElements();
				// 重新渲染
				vm.renderMathJax();
				// 注入Wiris图片隐藏样式
				const doc = vm.editor.document.$;
				if (!doc.getElementById('wiris-img-hide')) {
					const wirisStyle = doc.createElement('style');
					wirisStyle.id = 'wiris-img-hide';
					wirisStyle.textContent = `.Wirisformula { display: none !important; }`;
					doc.head.appendChild(wirisStyle);
				}
				// this.centerMathTypeDialog()
			},
			// setImgAutoSizes(img, type,ww,hh) {
			// 	let vm = this
			// 	if (type === 2) {
			// 		setTimeout(() => {
			// 			const body = vm.editor.document.$.body;
			// 			body.querySelectorAll(".latex-formula").forEach(el => {
			// 				const latex = el.getAttribute("text-latex") ||
			// 					"";
			// 				el.innerHTML = `$${latex}$`;
			// 			});
			// 			vm.originalHtml = vm.editor.getData();

			// 			vm.$emit("update:value", vm.originalHtml);

			// 			vm.$nextTick(() => {
			// 				vm.renderMathJax();
			// 			});
			// 		}, 500)
			// 	}else{
			// 		if (!img || img.tagName.toLowerCase() !== 'img') return;
			// 		let style = img.getAttribute('style') || '';
			// 		let scale = 7;
			// 		// 判断A4/A3
			// 		if (vm.imgStyle) {
			// 			if (vm.imgStyle.width < vm.imgStyle.height) {
			// 				scale = Math.ceil(Number(vm.imgStyle.width) / 710);
			// 			} else {
			// 				scale = Math.ceil(Number(vm.imgStyle.width) / 1420);
			// 			}
			// 		}
			// 		// 计算宽度
			// 		const nw = ww||img.naturalWidth || img.width || 1827;
			// 		let nh=hh||img.naturalHeight
			// 		let w = Math.ceil(nw / scale);
			// 		let h = Math.ceil(nh / scale);
			// 		// w = w > 520 ? 520 : w;
			// 		// 应用样式
			// 		if (!/\bwidth\s*:/.test(style)) {

			// 			if (h == undefined || Number(h) < 10) {
			// 				img.setAttribute('style',
			// 					`width:${w}px;height:auto;vertical-align:middle;`);
			// 			} else {
			// 				img.setAttribute('style',
			// 					`width:${w}px;height:${h}px;vertical-align:middle;`);
			// 			}
			// 			setTimeout(() => {
			// 				const body = vm.editor.document.$.body;
			// 				body.querySelectorAll(".latex-formula").forEach(el => {
			// 					const latex = el.getAttribute("text-latex") ||
			// 						"";
			// 					el.innerHTML = `$${latex}$`;
			// 				});
			// 				vm.originalHtml = vm.editor.getData();

			// 				vm.$emit("update:value", vm.originalHtml);

			// 				vm.$nextTick(() => {
			// 					vm.renderMathJax();
			// 				});
			// 			}, 500)
			// 		}
			// 	}

			// },
			// 初始化编辑器
			initEditor() {
				const vm = this;
				this.editor = window.CKEDITOR.replace(this.editorId, {
					height: "80%",
					resize_enabled: false,
					allowedContent: true,
					autoParagraph: false,
					fillEmptyBlocks: false,
					ignoreEmptyParagraph: false,
					// protectedSource: [
					//     /<img[^>]*>/gi // 直接保护所有 img 标签不被编辑器修改、过滤
					// ],
					language: "zh-cn",
					langCode: "zh-cn",
					contentsLangDirection: "ltr",
					toolbar: [
						["Cut", "Copy", "Paste", "Undo", "Redo"],
						["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript"],
						["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"],
						["NumberedList", "BulletedList", "Outdent", "Indent"],
						["Font", "FontSize", "TextColor", "BGColor"],
						["Link", "Unlink", "Image", "Table"],
						["ckeditor_wiris_formulaEditor"],
					],
					wiris: {
						// 强制alt属性输出LaTeX
						'image-attributes': {
							'alt': 'latex',
						},
						'latex-support': 'full', // 开启完整LaTeX语法支持
						// 'mathml-output': 'pmathml',
						'mathml-output': 'mathml',
						// 核心修改2：强制使用英文环境，禁用中文本地化
						'locale': 'en',
						// 核心修改3：移除所有注释（包括中文解释）
						'removeComments': true,
						// 可选：禁用额外的语义标签（进一步精简）
						'semantic-mathml': false,
						// 可选：输出紧凑格式（无多余空格/换行）
						'compact-mathml': true,
						// 新增：保留箭头的拉伸属性，不被Wiris过滤
						'preserve-mathml-attributes': ['stretchy', 'symmetric', 'minwidth',
							'width'
						],
						// 禁用Wiris对箭头宽度的自动修改
						'disable-auto-sizing': true,
					},
					extraPlugins: "font,colorbutton,justify,table,image,link,indent,list,ckeditor_wiris",

				});
				this.editor.on("instanceReady", () => {
					// 图片弹窗打开时：默认锁定宽高比
					CKEDITOR.on('dialogDefinition', function(evt) {
						try {
							const dialogName = evt.data.name;
							const dialogDef = evt.data.definition;
							if (dialogName !== 'image') return;

							const originalOnShow = dialogDef.onShow;
							dialogDef.onShow = function() {
								originalOnShow.call(this);
								const dialog = this;

								setTimeout(() => {
									try {
										const btn = dialog._.element.$
											.querySelector(
												'[title="锁定比例"]');
										if (btn) {
											btn.setAttribute('aria-checked',
												'true');
											btn.className =
												'cke_btn_locked cke_on';
										}
										dialog.lockRatio = true;
										dialog._.lockRatio = true;
									} catch (e) {}
								}, 500);
							};
						} catch (e) {}
					});
					// 【稳定版】自动计算图片宽度
					
					

					vm.editor.setData(vm.value || "");
					vm.originalHtml = vm.value;
					// vm.fixFormulaElements();
					
					
					vm.watchWirisDialog();
				});
			},

		},
	};
</script>

<style>
	/* 编辑器布局样式 */
	.cke_chrome {
		height: 100% !important;
		display: flex !important;
		flex-direction: column !important;
	}

	.cke_inner,
	.cke_contents {
		flex: 1 !important;
	}

	/* 弹窗样式 */
	.cke_dialog {
		position: fixed !important;
		top: 50% !important;
		left: 50% !important;
		transform: translate(-50%, -50%) !important;
		margin: 0 !important;
		z-index: 99999 !important;
		box-sizing: border-box !important;
	}

	.cke_dialog_background_cover {
		position: fixed !important;
		top: 0 !important;
		left: 0 !important;
		width: 100vw !important;
		height: 100vh !important;
		z-index: 99998 !important;
	}

	/* 公式相关样式 */
	.latex-formula {
		color: transparent !important;
		user-select: none;
		position: relative !important;
		z-index: 999 !important;
		pointer-events: auto !important;
		display: inline-block !important;
	}

	.wrs_handWrapper {
		display: none;
	}

	.wrs_tickContainer {
		display: none;
	}

	.wrs_linksContainer {
		display: none;
	}

	.Wirisformula {
		display: none !important;
		pointer-events: none !important;
		position: absolute !important;
		z-index: 1 !important;
	}

	.MJX-TEX {
		display: none !important;
	}

	.mjx-chtml {
		display: inline-block !important;
		max-width: 100%;
		width: auto !important;
	}

	mjx-math {
		display: inline-block !important;
		border: 1px dashed #ccc;
		/* 调试用，可删 */
	}

	/* ============================================= */
	/* 🔥 1. 处理 mover 结构：文字在上、箭头在下（如 O₂/点燃） */
	/* ============================================= */
	mjx-mover,
	mover {
		display: inline-flex !important;
		flex-direction: column !important;
		/* 箭头在上，文字在下 */
		align-items: center !important;
		width: auto !important;
		min-width: 4em !important;
		/* 保证箭头最小可见宽度 */
	}

	/* mover 里的箭头：拉伸且对齐基线，不改变文字垂直距离 */
	mjx-mover mjx-mo[stretchy="true"],
	mover mo[stretchy="true"] {
		width: 100% !important;
		/* 填满父容器，实现自适应拉伸 */
		vertical-align: baseline !important;
		transform: translateY(0) !important;
		/* 取消默认上移 */
		margin: 0 !important;
	}

	/* mover 里的文字：紧贴箭头下方，保持原有垂直距离 */
	mjx-mover mjx-mtext,
	mover mtext {
		display: inline-block !important;
		transform: translateY(-0.1em) !important;
		/* 微调贴紧箭头，不改变整体间距 */
		vertical-align: bottom !important;
	}

	/* ============================================= */
	/* 🔥 2. 处理 munder 结构：文字在下、箭头在上（如 H₂O/→） */
	/* ============================================= */
	mjx-munder,
	munder {
		display: inline-flex !important;
		flex-direction: column-reverse !important;
		/* 文字在下，箭头在上 */
		align-items: center !important;
		width: auto !important;
		min-width: 4em !important;
	}

	/* munder 里的箭头：拉伸且对齐基线，不改变文字垂直距离 */
	mjx-munder mjx-mo[stretchy="true"],
	munder mo[stretchy="true"] {
		width: 100% !important;
		vertical-align: baseline !important;
		transform: translateY(0) !important;
		margin: 0 !important;
	}

	/* munder 里的文字：紧贴箭头上方，保持原有垂直距离 */
	mjx-munder mjx-mtext,
	munder mtext {
		display: inline-block !important;
		transform: translateY(0.1em) !important;
		/* 微调贴紧箭头，不改变整体间距 */
		vertical-align: top !important;
	}

	/* ============================================= */
	/* 🔥 3. 等号 ═ 保持拉伸（不受影响） */
	/* ============================================= */
	mjx-mo:contains("═") {
		stretchy: true !important;
		min-width: 6em !important;
		width: 100% !important;
		display: inline-block !important;
		transform: translateY(0.2em) !important;
		/* 等号垂直微调 */
	}

	mjx-munder {
		width: auto !important;
		min-width: 3em !important;
		padding: 0 0.15em !important;
	}

	/* mpadded 垂直偏移（保留你原来的） */
	mpadded {
		transform: translateY(0.3em) !important;
		width: auto !important;
	}
</style>